import { fetchBasicJsonPostJson, fetchBasicJsonPost, fetchBasicUrlPost } from '@/script/common';

export default {
    getPatients: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicJsonPostJson('/Nurse/GetPatients', {
            data: parameters,
            signal
        });
    },
    getMedsForPatient: params =>
        fetchBasicJsonPostJson('/Nurse/GetPatientPrescriptions', {
            data: params
        }),
    saveMedForPatient: medData =>
        fetchBasicJsonPost('/Nurse/SavePreDrugTreatment', { data: medData }),
    getTakenMeds: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicJsonPostJson('/Nurse/GetPreDrugTreatment', {
            data: parameters,
            signal
        });
    },
    deleteTakenMeds: id =>
        fetchBasicJsonPost('/Nurse/DeletePreDrugTreatment', { data: id }),
    saveSpecMed: params => {
        return fetchBasicJsonPost('/Nurse/SaveDrugTreatment', {
            data: params
        });
    },
    addMkurnal: (prescriptionId, date, prescriptionTime, brunvaId, diagnosisNumber) => {
        return fetchBasicUrlPost('/Consumption/AddMkurnal', {
            data: {
                prescriptionId,
                date,
                prescriptionTime,
                brunvaId,
                diagnosisNumber
            }
        });
    }
};
